import { Component, inject, input, output, OutputEmitterRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { DaysCounterStatisticsComponent } from '@app/shared/components/days-counter-statistics/days-counter-statistics.component';
import { HoursStatisticsComponent } from '@app/shared/components/hours-statistics/hours-statistics.component';
import { ProjectAvatarComponent } from '@app/shared/components/project-avatar/project-avatar.component';
import { Project } from '@app/shared/types/models/project/project.model';
import { disableScroll, enableScroll } from '@app/shared/utils/scroll-utils';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-company-project-item',
  imports: [
    MatIconModule,
    MatCardModule,
    MatMenuModule,
    TranslatePipe,
    MatButtonModule,
    HoursStatisticsComponent,
    DaysCounterStatisticsComponent,
    ProjectAvatarComponent
  ],
  templateUrl: './company-project-item.component.html'
})
export class CompanyProjectItemComponent {
  private readonly router = inject(Router);

  protected readonly enableScroll = enableScroll;
  protected readonly disableScroll = disableScroll;

  public project = input.required<Project>();
  public isSelectedProject = input<boolean>(false);
  public isActiveProject = input<boolean>(false);
  public isArchivedProject = input<boolean>(false);
  public isDraftProject = input<boolean>(false);
  public setActiveProject: OutputEmitterRef<Project> = output<Project>();
  public archiveProject: OutputEmitterRef<Project> = output<Project>();
  public restoreProject: OutputEmitterRef<Project> = output<Project>();
  public deleteProject: OutputEmitterRef<Project> = output<Project>();
  public editProject: OutputEmitterRef<Project> = output<Project>();
  public exportTaskImportTemplate: OutputEmitterRef<Project> = output<Project>();

  protected onProjectSelect(): void {
    this.setActiveProject.emit(this.project());
    const redirectUrl = this.project().getProjectTasksViewUrl();
    void this.router.navigateByUrl(redirectUrl);
  }
}
